import { useEffect, useRef } from 'react';

/**
 * Telegram Login Widget — встраивает официальный скрипт telegram-widget.js.
 *
 * Используем data-auth-url (redirect-flow), а не data-onauth (JS-callback).
 * Причина: в survivors был incident с silent fail data-onauth на mobile TG —
 * popup закрывается без вызова window.onTelegramAuth. Redirect-flow стабилен.
 *
 * Перед использованием:
 *   1. Создать бота через @BotFather (/newbot)
 *   2. Привязать domain: /setdomain → ввести bot username → ввести med.cheslav.space
 *   3. Положить BOT_USERNAME в VITE_BOT_USERNAME env
 *
 * См. https://core.telegram.org/widgets/login
 */
export function TelegramLogin({ botUsername }: { botUsername: string }) {
  const mountRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mountRef.current) return;

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-request-access', 'write');
    // Backend endpoint, который валидирует HMAC + whitelist и редиректит.
    // В dev (vite proxy) /api/* → http://localhost:8000/*.
    script.setAttribute('data-auth-url', '/api/auth/telegram/widget');

    mountRef.current.appendChild(script);

    return () => {
      if (mountRef.current) mountRef.current.innerHTML = '';
    };
  }, [botUsername]);

  return <div ref={mountRef} />;
}
